/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Form.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
// Form/Form* components are exceptions for react-hook-form
// eslint-disable-next-line no-restricted-imports
import { useFormContext } from 'react-hook-form';
import ButtonPrimary from './ButtonPrimary';
import { ButtonSizes } from './ButtonBase';
var FormSubmitButton = function (_a) {
    var className = _a.className, icon = _a.icon, isDisabled = _a.isDisabled, isFullWidth = _a.isFullWidth, isLoading = _a.isLoading, label = _a.label, size = _a.size;
    var formState = useFormContext().formState;
    // `formState` must be read directly (as opposed to reading  subkeys like `formState.isValid`) due to
    // react-hook-form's use of a Proxy object for performance reasons.
    // https://react-hook-form.com/api#formState
    var isValid = formState.isValid;
    return (React.createElement(ButtonPrimary, { buttonType: 'submit', className: className, icon: icon, isDisabled: !isValid || isDisabled, isFullWidth: isFullWidth, isLoading: isLoading, label: label, size: size }));
};
FormSubmitButton.defaultProps = {
    className: '',
    isDisabled: false,
    isFullWidth: false,
    isLoading: false,
    label: 'Submit',
    size: ButtonSizes.MEDIUM
};
FormSubmitButton.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    size: PropTypes.oneOf(Object.values(ButtonSizes))
};
export default FormSubmitButton;
//# sourceMappingURL=Form.SubmitButton.js.map